<div
  *ngIf="currentContainerMode === containerModes.ViewAsStudent"
  class="alert alert-warning c-list-alert c-list-alerts__student-view alert--flex qa-view-list-as-student"
  role="status"
>
  <div>
    <strong i18n="@@viewListAsStudent-status-studentView">Student view</strong>
    <span i18n="@@viewListAsStudent-message-studentView"
      >You are viewing this list as a student. Edits are disabled</span
    >
  </div>
  <a
    class="btn btn-alert--primary"
    routerLink="../edit"
    [skipLocationChange]="true"
  >
    <i class="fas fa-sign-out" aria-hidden="true"></i>&nbsp;
    <ng-container i18n="@@viewListAsStudent-btn-exitStudentView"
      >Exit student view</ng-container
    >
  </a>
</div>
